import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "application",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeHamburger && _ctx.closeHamburger(...args)))
  }, [
    _createVNode(_component_Navigation, { ref: "navigation" }, null, 512),
    _createVNode(_component_router_view),
    _createVNode(_component_Footer)
  ]))
}